export const ENFORCED = 'ENFORCED';
export const UNENFORCED = 'UNENFORCED';

export const ARCHIVED = 'ARCHIVED';
